import { render, staticRenderFns } from "./Levy.vue?vue&type=template&id=817aae58&scoped=true&"
import script from "./Levy.vue?vue&type=script&lang=js&"
export * from "./Levy.vue?vue&type=script&lang=js&"
import style0 from "./Levy.vue?vue&type=style&index=0&id=817aae58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817aae58",
  null
  
)

export default component.exports